import i18n from '@/settings/i18n/i18n';

export const translateErrorCode = (errorCode: string): string => i18n.t(`errorCodes.${errorCode}`, { defaultValue: '' });
